import styled from '@emotion/styled';
import { theme } from '@vfit/shared/themes';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${theme.spacing.sm}
`;

export const Input = styled.input`
  display: inline-block;
  text-align: center;
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h5};
  line-height: ${theme.typography.lineHeight.body2};
  height: 30px;
  width: ${theme.spacing.lg};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: solid 1px;
  border-color: ${theme.colors.text.primary};
  padding: 0;

  &[value=''] {
    border-color: ${theme.colors.border.default};
  }

  :focus {
    outline: none;
    border-color: ${theme.colors.interactive.hooverMvaSecondary};
  }

  :disabled {
    background-color: transparent;
  }
`;

export const ErrorMessage = styled.p`
  position: relative;
  animation: fadein 2s;
  color: ${theme.colors.brand.primary};
  font-size: ${theme.typography.fontSize.body3};
  line-height: 0;
  font-family: ${theme.typography.fontFamily.secondary};
  text-align: center;

  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`;

